module.exports = __webpack_public_path__ + "img/logo-login.d4469046.png";